import { esColdPalettes } from "../../../../Posts/02-tonos/11-paletas-frias/coldPalettes.js";
import * as React from 'react';
export default {
  esColdPalettes,
  React
};